import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { InputTextComponent } from "@/components/FormInputs/InputText/InputText";
import { type FormFieldComponentProps } from "@/lib/types/types";
export const SMSCodeComponent = ({
  onChange,
  value,
  isErrored,
  errorId,
  placeholder = "",
}: FormFieldComponentProps) => {
  const { msg } = useMessage();
  const getErrorMessage = (errorId) => {
    switch (errorId) {
      case "invalidSMSCode":
        return (
          <FormattedHTMLMessage
            id="step.smsLoop.errors.codeVerification"
            defaultMessage="Verification code could not be validated."
          />
        );
      case "expiredSMSCode":
        return (
          <FormattedHTMLMessage
            id="step.smsLoop.errors.codeExpired"
            defaultMessage="Verification code expired."
          />
        );
      default:
        return <FormattedHTMLMessage id="errorId.unknownError" defaultMessage="Unknown Error" />;
    }
  };

  return (
    <div className="sid-field sid-sms-code-id">
      <div className="sid-l-space-top-md" />
      {isErrored ? <div className="sid-field-error">{getErrorMessage(errorId)}</div> : null}

      <InputTextComponent
        id="sms-code"
        isErrored={isErrored}
        required
        placeholder={placeholder || msg({ id: "smsCodePlaceholder" })}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
